import Image from "next/image";
import Link from "next/link";
import { CategoriesResponse } from "@/types/category";
import { Typography } from "../typography";
import NavbarDropdown from "./navbar-dropdown";
import { MobileNavbar } from "./mobile-navbar";
import CartCount from "./cart-count";
import SearchBar from "./search-bar";

export const ContactSupport = () => (
  <Link href="/contact-us" className="px-2 gap-2 flex items-center">
    <Image
      src="/img/call-headset.svg"
      width={23}
      height={23}
      alt="customer support"
    />
    <Typography tag="span" className="text-nowrap">
      Support
    </Typography>
  </Link>
);

const CompanyLogo = () => (
  <Link href="/" className="flex items-center">
    <Image
      src="/img/company-logo-primary.svg"
      className="m-5 ml-0"
      height={80}
      width={170}
      alt="Logo"
    />
  </Link>
);
const CompanyLogoSmallerScreen = () => (
  <Link href="/" className="flex items-center">
    <Image
      src="/img/Stroke.svg"
      className="m-5 "
      height={40}
      width={40}
      alt="Logo"
    />
  </Link>
);

interface Props {
  categories: CategoriesResponse[];
}

const message = "Free Delivery on orders above $300 - Australia Wide*";

export default ({ categories }: Props) => (
  <div className="sticky top-0 z-20 shadow-md h-fit">
    <div className="relative font-semibold bg-primary py-1.5 shadow-lg text-[#FDDB6C] overflow-hidden">
      <div className="whitespace-nowrap flex animate-marquee">
        <span className="mx-36">{message}</span>
        <span className="mx-36">{message}</span>
        <span className="mx-36">{message}</span>
        <span className="mx-36">{message}</span>
        <span className="mx-36">{message}</span>
        <span className="mx-36">{message}</span>
      </div>
    </div>

    <nav className="mx-auto bg-white ">
      <div className="flex flex-col max-w-screeen-2xl ">
        <div className="container max-w-screen-2xl mx-auto items-center justify-between ">
          {/* navbar for smaller scrren */}
          <div className="flex lg:hidden justify-between w-full  px-2">
            <div className="flex flex-row ">
              <MobileNavbar categories={categories} />
              <CompanyLogoSmallerScreen />
            </div>
            <div className="flex items-center p-2">
              <Link
                href="/cart"
                className="p-2 rounded flex items-center relative"
              >
                <Image
                  src="/img/ShoppingCartPrimary.svg"
                  height={35}
                  width={35}
                  alt="shopping cart"
                />

                <CartCount />
              </Link>
            </div>
          </div>

          {/* Navbar row 1 for large scren */}
          <div className="hidden container px-4 lg:flex items-center justify-between">
            <CompanyLogo />

            <div className="hidden lg:inline-block py-2 px-4">
              <div className="relative  xl:w-[700px] lg:w-[400px] w-[280px]">
                <SearchBar />
              </div>
            </div>

            <div className="hidden gap-2  lg:flex">
              <div className="flex items-center container lg:flex-row flex-col gap-2">
                <NavbarDropdown categories={categories} />
                <ContactSupport />
              </div>
              <Link
                href="/cart"
                className="p-3 rounded h-fit m-auto flex items-center  relative  "
              >
                <Image
                  src="/img/ShoppingCartPrimary.svg"
                  width={35}
                  height={35}
                  className="w-8 aspect-square"
                  alt="cart icon "
                />
                <CartCount />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
);
